/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaText/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function TysiaText({
  children,
  viewPath = "/DesignSystem/TysiaText",
  backgroundColor,
  color,
  className = "text",
  fontFamily = "Inter, sans-serif",
  fontSize = 13,
  fontStyle = "normal",
  lineHeight = "20px",
  marginTop = 0,
  marginBottom = 0,
  marginRight = 0,
  marginLeft = 0,
  paddingTop = 0,
  paddingRight = 0,
  paddingBottom = 0,
  paddingLeft = 0,
  textAlign = "left",
  width = "auto",
  maxWidth = "auto",
  minWidth = "auto",
  height = "auto",
  maxHeight = "auto",
  textOverflow = "clip",
  order = "no",
  whiteSpace = "normal",
  overflowX,
  overflowY,
  hyphens = "none",
  textDecoration = "none",
  textUnderlineOffset,
  textTransform = "none",
  cursor,
  letterSpacing,
  display = "flex",
  opacity,
  text = "",
  title,
  flexGrow,
  flexShrink,
  flexBasis,
  wordBreak,
  size,
  weight
  
}) {
let dtTysiatextColorPrimaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaText.color.primary.base'
        })
let colorOrdtTysiatextColorPrimaryBase = color ?? dtTysiatextColorPrimaryBase
  return (<React.Fragment
>
<span
  data-testid="TysiaText.Text"
  data-view-path={viewPath}
 textUnderlineOffset={textUnderlineOffset}
 title={title}
 style={{'--bc-1-1bFlFs': backgroundColor,'--c-2-1bFlFs': colorOrdtTysiatextColorPrimaryBase,'--ff-3-1bFlFs': fontFamily,'--fs-5-1bFlFs': fontStyle,'--mt-8-1bFlFs': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-9-1bFlFs': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--mr-10-1bFlFs': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--ml-11-1bFlFs': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--pt-12-1bFlFs': typeof paddingTop === 'number' ? `${paddingTop}px` : paddingTop,'--pr-13-1bFlFs': typeof paddingRight === 'number' ? `${paddingRight}px` : paddingRight,'--pb-14-1bFlFs': typeof paddingBottom === 'number' ? `${paddingBottom}px` : paddingBottom,'--pl-15-1bFlFs': typeof paddingLeft === 'number' ? `${paddingLeft}px` : paddingLeft,'--ta-16-1bFlFs': textAlign,'--w-17-1bFlFs': typeof width === 'number' ? `${width}px` : width,'--mw-18-1bFlFs': typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth,'--mw-19-1bFlFs': typeof minWidth === 'number' ? `${minWidth}px` : minWidth,'--h-20-1bFlFs': typeof height === 'number' ? `${height}px` : height,'--mh-21-1bFlFs': typeof maxHeight === 'number' ? `${maxHeight}px` : maxHeight,'--to-22-1bFlFs': textOverflow,'--o-23-1bFlFs': order,'--ws-24-1bFlFs': whiteSpace,'--ox-25-1bFlFs': overflowX,'--oy-26-1bFlFs': overflowY,'--h-27-1bFlFs': hyphens,'--td-28-1bFlFs': textDecoration,'--tt-29-1bFlFs': textTransform,'--c-30-1bFlFs': cursor,'--ls-31-1bFlFs': typeof letterSpacing === 'number' ? `${letterSpacing}px` : letterSpacing,'--d-32-1bFlFs': display,'--o-33-1bFlFs': opacity,'--fg-34-1bFlFs': flexGrow,'--fs-35-1bFlFs': flexShrink,'--fb-36-1bFlFs': typeof flexBasis === 'number' ? `${flexBasis}%` : flexBasis,'--wb-37-1bFlFs': wordBreak,'--fs-4-1bFlFs': size === "tiny" ? "11px" : size === "small" ? "12px" : size === "normal" ? "13px" : size === "large" ? "14px" : size === "extralarge" ? "18px" : typeof fontSize === 'number' ? `${fontSize}px` : fontSize,'--lh-6-1bFlFs': size === "tiny" ? "13px" : size === "small" ? "16px" : size === "normal" ? "20px" : size === "large" ? "20px" : size === "extralarge" ? "24px" : lineHeight,'--fw-7-1bFlFs': weight === "thin" ? 100 : weight === "extralight" ? 200 : weight === "light" ? 300 : weight === "regular" ? 400 : weight === "medium" ? 500 : weight === "semibold" ? 600 : weight === "bold" ? 700 : weight === "extrabold" ? 800 : weight === "black" ? 900 : 400}}
 className={`views-text ${className} ${styles.Text}`}
>
{text}
</span>
{children}
</React.Fragment>)
}